import request from '../utils/request';
import { routerRedux } from 'dva/router';
import Config,{MethodType} from '../config'

let order = {
    namespace:'order',
    state:{
        orders :[],
        AAE002 : '',
        AAE004 : '',
        message : null
    },
    effects:{
        *getOrder({payload},{call,put}){
           let res = yield call(request('xlc/order/Order',{
                method : MethodType.GET,
                params : { appid:Config.appid,
                    data :{...payload}
                }
            }));
        
            yield put({type:'update',payload:{orders:res.data}});
        },
        *getWjsOrder({payload},{call,put}){
            let res = yield call(request('xlc/order/WjsOrder',{
                 method : MethodType.GET,
                 params : { appid:Config.appid,
                     data :{...payload}
                 }
             }));
             return res.data;
         },
         *shouHuoQueRenUpdate({payload},{call,put}){
            let res = yield call(request('xlc/order/ShouHuoQueRen',{
                method : MethodType.POST,
                params : { appid:Config.appid,
                    data :{...payload}
                }
            }));
            return res.data;
         },
         *routerZdrOrder({payload},{call,put}){
            yield put({type:"update",payload:{
                AAE002:payload.AAE002,
                AAE004:payload.AAE004}});
            yield put(routerRedux.push(payload.route));

        },
        *getZdrOrder({payload},{call,put}){
            let res = yield call(request('xlc/order/Order/getZdrOrder',{
                 method : MethodType.GET,
                 params : { appid:Config.appid,
                     data :{...payload}
                 }
             }));
             return res.data;
         },
         *getZdrWjsOrder({payload},{call,put}){
            let res = yield call(request('xlc/order/Order/getZdrWjsOrder',{
                 method : MethodType.GET,
                 params : { appid:Config.appid,
                     data :{...payload}
                 }
             }));
             return res.data;
         },
         //获取制单人信息
        *ae01GetZdr({payload},{call,put}){
            let res = yield call(request('ghs/ae/Ae01/ae01GetZdr',{
                method : MethodType.GET,
                params : { appid:Config.appid,
                    data :{...payload}
                }
            }));
            return res.data;
        },
        *af01_Sign({payload},{call,put}){
            let res = yield call(request('/ghs/af/Af01/af01_Sign',{
                method : MethodType.POST,
                data :  payload,
                
            }));
            return res.data[0];
        },
       
    },
    reducers:{
        update(state, { payload }) {
            return {
                ...payload
            }
        }   
    }
};

export default order;